import { connectedStore } from '../../store';
import getIntegrationUserData from '../selectors/user-data';

const getUserData = () => {
  const store = connectedStore.get();
  const state = store.getState();

  return getIntegrationUserData(state);
};

export default getUserData;
